<template>
<div class="TTL-el-form-search-regular">
    
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="name" label="续费名称" align="center">
            <template #default="scope">
                <div class="TTL-renewname" @click="$parent.JUMPVIEW({name:'EsPaymentDetail',param:{id:scope.row.id}})">{{scope.row.name}}</div>
            </template>
        </el-table-column>
        <el-table-column label="上下架" align="center">
            <template #default="scope">
                <el-switch v-model="scope.row.isshow" @change="ChangeShow(scope.row)" />
            </template>
        </el-table-column>
    </el-table>
</div>



</template>

<script>
import INTERFACE_MODEL_PAYMENT from '@/Interface/Es/payment';
export default {

    components:{},
    data() {
        return {
            objloading:'payment',
            list:[],

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_PAYMENT.GET_PAYMENT_LIST().then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.list=res.data;
                 for(var i in this.list) this.list[i].isshow=this.list[i].isshow==1 ? true : false;
            });
        },


        /** 修改支付上下架类型 **/
        ChangeShow(item) {
            INTERFACE_MODEL_PAYMENT.UPDATE_SHOW({id:item.id,isshow:item.isshow}).then((res) => {
                 if(res.status > 0) return false;
            });
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.TTL-info {display: inline-flex;justify-content: center;}
::v-deep(.TTL-info .TTL-input .el-input__inner) {text-align: center;}
.TTL-renewname {color:#666eeb;cursor: pointer;}
</style>